export const POPULAR_CITIES = [
  {
    city_name: 'Mumbai',
    airport_name: 'Chhatrapati Shivaji International Airport',
    airport_code: 'BOM',
    country_name: 'India',
  },
  {
    city_name: 'Chennai',
    airport_name: 'Chennai International Airport',
    airport_code: 'MAA',
    country_name: 'India',
  },
  {
    city_name: 'Bangalore',
    airport_name: 'Kempgowda International Airport',
    airport_code: 'BLR',
    country_name: 'India',
  },
  {
    city_name: 'Goa',
    airport_name: 'Dabolim Airport',
    airport_code: 'GOI',
    country_name: 'India',
  },
  {
    city_name: 'Kolkata',
    airport_name: 'Nejaji Subash Chadra Bose International Airport',
    airport_code: 'CCU',
    country_name: 'India',
  },
];
export const FLIGHT_TABS = [
  {
    id: 1,
    label: 'FLIGHT_INFORMATION',
    value: 'Flight Information',
  },
  {
    id: 2,
    label: 'FARE_DETAILS',
    value: 'Fare Details',
  },
  {
    id: 3,
    label: 'BAGGAGE_RULES',
    value: 'Baggage Rules',
  },
  {
    id: 4,
    label: 'CANCELLATION_RULES',
    value: 'Cancellation Rules',
  },
];

export const BOOKING_TABS = [
  {
    id: 1,
    label: 'UPCOMING',
    value: 'Upcoming',
  },
  {
    id: 2,
    label: 'CANCELLED',
    value: 'Cancelled',
  },
  {
    id: 3,
    label: 'COMPLETED',
    value: 'Completed',
  },
];
